import { memo, useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../../Components/Shared/PageHeader';
import { DocumentType, InvitationRecipientType } from '../../../types';
import EnrollmentDocumentsForm from '../EnrollmentDocumentsForm';
import EnrollmentInvitationRecipientsForm from '../EnrollmentInvitationRecipientsForm';

type StudentDocumentsProps = {
  enrollmentForm: UseFormReturn<any>;
  studentFromForm: any;
  invitationRecipients: InvitationRecipientType[];
  documents: DocumentType[];
};

const StudentDocuments = memo(
  ({ enrollmentForm, studentFromForm, invitationRecipients, documents }: StudentDocumentsProps) => {
    const { t } = useTranslation();

    const handleInvitationRecipientsSave = useCallback(
      (d) => {
        if (d.data) {
          enrollmentForm.setValue('invitationRecipients', d.data);
        }
      },
      [enrollmentForm]
    );

    const handleDocumentsSave = useCallback(
      (d) => {
        if (d.data) {
          enrollmentForm.setValue('documents', d.data);
        }
      },
      [enrollmentForm]
    );

    return (
      <>
        <PageHeader pageName={'Enrollment'} classes="enrollments-page" />
        <h1 className="mb-4 text-2xl font-bold">
          {t('enrollments.pageTitle', { name: studentFromForm?.displayName ?? 'N/A' })}
        </h1>
        <div className="mb-6 overflow-hidden rounded-md border-2 border-gray-300 bg-gray-50 p-4">
          <EnrollmentInvitationRecipientsForm
            invitationRecipients={invitationRecipients}
            onSave={handleInvitationRecipientsSave}
          />
        </div>
        <div className="mb-6 overflow-hidden rounded-md border-2 border-gray-300 bg-gray-50 p-4">
          <EnrollmentDocumentsForm documents={documents} onSave={handleDocumentsSave} enrollmentForm={enrollmentForm} />
        </div>
      </>
    );
  }
);

StudentDocuments.displayName = 'StudentDocuments';

export default StudentDocuments;
